import pagination from './pagination/index';
import treeTable from './treeGrid/treeTable.vue';
import treeSelect from './treeSelect/treeSelect.vue';
import projectTreeSelect from './treeSelect/projectTreeSelect.vue';
import treeMultiSelect from './treeSelect/treeMultiSelect';
import treeMultiBuild from '../module/aicty/proBuilder/treeMultiBuild.vue';
import fileExport from './export/fileExport';
import fileImport from './import/fileImport';
import websocket from './websocket/websocket'
import bopWrap from './wrap/index.vue';
import vueUpload from "../components/upload/upload.vue";
import securityCode from "../components/securityCode/securityCode.vue";
import elButton from '../components/defaultElement/button.vue';
import supplierTableSelect from '../components/supplier/supplierTableSelect.vue'
import attachmentsEdit from './accessory/attachmentsEdit.vue'
import populregisterRef from './populregister/populregisterRef.vue'
import populregisterSelect from './populregister/populregisterSelect.vue'
import dataImporter from './dataImport/DataImporter.vue'
import proRoomRegisterRef from './proRoomRegister/proRoomRegisterRef.vue'
import proRoomRegisterSelect from './proRoomRegister/proRoomRegisterSelect.vue'
import houseRegisRef from './houseRegis/houseRegisRef.vue'
import houseRegisSelect from './houseRegis/houseRegisSelect.vue'
import partyMemberRegisterRef from './partyMemberRegister/partyMemberRegisterRef.vue'
import partyMemberRegisterSelect from './partyMemberRegister/partyMemberRegisterSelect.vue'
import proCostnormRef from './proCostnormRegister/proCostnormRef.vue'
import proCostnormSelect from './proCostnormRegister/proCostnormSelect.vue'
import proCostnormRefList from './proCostnormRegister/proCostnormRefList.vue'
import proCostnormSelectList from './proCostnormRegister/proCostnormSelectList.vue'
import proRewardPunishRegisterRef from './proRewardPunishRegister/proRewardPunishRegisterRef.vue'
import proRewardPunishRegisterSelect from './proRewardPunishRegister/proRewardPunishRegisterSelect.vue'
import houseCustDefendRef from './houseRegis/houseCustDefendRef.vue'
import graphCoordsCreator from "./graphCoordsCreator/graphCoordsCreator.vue"
import proDeviceRegisterRef from './proDeviceRegister/proDeviceRegisterRef.vue'
import proDeviceRegisterSelect from './proDeviceRegister/proDeviceRegisterSelect.vue'
import proPersonRef from './proPerson/proPersonRef.vue'
import proPersonSelect from './proPerson/proPersonSelect.vue'

const components = [
  pagination,
  treeTable,
  treeSelect,
  projectTreeSelect,
  treeMultiSelect,
  treeMultiBuild,
  fileExport,
  fileImport,
  websocket,
  bopWrap,
  vueUpload,
  securityCode,
  elButton,
  supplierTableSelect,
  attachmentsEdit,
  populregisterRef,
  populregisterSelect,
  dataImporter,
  proRoomRegisterRef,
  proRoomRegisterSelect,
  houseRegisRef,
  houseRegisSelect,
  partyMemberRegisterRef,
  partyMemberRegisterSelect,
  proCostnormRef,
  proCostnormSelect,
  proCostnormRefList,
  proCostnormSelectList,
  proRewardPunishRegisterRef,
  proRewardPunishRegisterSelect,
  houseCustDefendRef,
  graphCoordsCreator,
  proDeviceRegisterRef,
  proDeviceRegisterSelect,
  proPersonRef,
  proPersonSelect,

];

export default function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  });
};



// WEBPACK FOOTER //
// ./src/components/index.js